var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHelp = function SvgHelp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5C15.0899 6.5 18 9.41015 18 13C18 16.5899 15.0899 19.5 11.5 19.5C7.91015 19.5 5 16.5899 5 13C5 9.41015 7.91015 6.5 11.5 6.5ZM11.4535 15.7083C11.1479 15.7083 10.9002 15.9508 10.9002 16.25C10.9002 16.5492 11.1479 16.7917 11.4535 16.7917C11.759 16.7917 12.0068 16.5492 12.0068 16.25C12.0068 15.9508 11.759 15.7083 11.4535 15.7083ZM11.4535 9.75C10.5062 9.75 9.67339 10.3379 9.3647 11.1991C9.26351 11.4813 9.41523 11.7905 9.70357 11.8895C9.99192 11.9886 10.3077 11.8401 10.4089 11.5578C10.5631 11.1274 10.9798 10.8333 11.4535 10.8333C12.0646 10.8333 12.5601 11.3184 12.5601 11.9167C12.5601 12.515 12.0646 13 11.4535 13H11.4518H11.4418C11.1427 13 10.9002 13.2425 10.9002 13.5417V14.625C10.9002 14.9242 11.1427 15.1667 11.4418 15.1667C11.741 15.1667 11.9835 14.9242 11.9835 14.625L11.9835 14.0208C12.9498 13.7883 13.6667 12.9344 13.6667 11.9167C13.6667 10.72 12.6758 9.75 11.4535 9.75Z",
    fill: "#999999"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help.53720631fe3bb623ac3daa94891e6b69.svg";